/* Hover is temporary; explicit Door / Room choices persist for touch and keyboard. */
if (!customElements.get('cdw-finish-preview')) {
  customElements.define('cdw-finish-preview', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const visual = this.querySelector('.cdw-finish-card__visual');
      const controls = this.querySelector('.cdw-finish-card__view-switch');
      const room = this.querySelector('.cdw-finish-card__room img');
      if (!visual || !controls || !room) return;

      let selectedView = this.selectedView || 'door';
      let roomAvailable = true;
      const buttons = [...controls.querySelectorAll('[data-finish-view]')];
      const roomButton = buttons.find((button) => button.dataset.finishView === 'room');
      if (roomButton) {
        this.roomLabel ||= roomButton.getAttribute('aria-label');
        roomButton.disabled = false;
        roomButton.setAttribute('aria-label', this.roomLabel);
      }
      const show = (view) => {
        this.dataset.view = view === 'room' && roomAvailable ? 'room' : 'door';
        buttons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.finishView === this.dataset.view));
        });
      };
      const unavailable = () => {
        roomAvailable = false;
        selectedView = 'door';
        this.selectedView = 'door';
        if (roomButton) {
          roomButton.disabled = true;
          roomButton.setAttribute('aria-label', 'Installed-kitchen image unavailable');
        }
        show('door');
      };

      controls.addEventListener('click', (event) => {
        const button = event.target.closest('[data-finish-view]');
        if (!button || !controls.contains(button) || button.disabled) return;
        selectedView = button.dataset.finishView === 'room' ? 'room' : 'door';
        this.selectedView = selectedView;
        show(selectedView);
      }, options);
      visual.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') show('room');
      }, options);
      visual.addEventListener('pointerleave', () => show(selectedView), options);
      visual.addEventListener('pointercancel', () => show(selectedView), options);
      room.addEventListener('error', unavailable, options);
      if (room.complete && room.naturalWidth === 0) unavailable();
      show(selectedView);
      controls.hidden = false;
    }

    disconnectedCallback() {
      this.events?.abort();
    }
  });
}
